module.exports = __webpack_public_path__ + "static/img/red_envelope_bottom.23a8fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red_envelope_bottom.png
// module id = hMiN
// module chunks = 1